<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [appearance]="'futuristic'" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigationItems" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-8" src="assets/icons/shell_logo.png">
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div
                    class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{user?.fullname}}
                </div>
                <div
                    class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{user?.email}}
                </div>
            </div>
            <div class="w-full mt-4" *ngIf="showSubsidiarySelector; else selectedSubsidiaryLabelTpl">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Subsidiaria</mat-label>
                    <input
                        matInput
                        [formControl]="subsidiaryControl"
                        [matAutocomplete]="subsidiaryAutocomplete"
                        placeholder="Buscar por código o nombre"
                        autocomplete="off"
                    />
                    <button
                        *ngIf="subsidiaryControl.value"
                        mat-icon-button
                        matSuffix
                        type="button"
                        aria-label="Limpiar selección"
                        (click)="clearSubsidiarySelection()"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-autocomplete
                        #subsidiaryAutocomplete="matAutocomplete"
                        [displayWith]="formatSubsidiaryName.bind(this)"
                        (optionSelected)="onSubsidiarySelected($event)"
                    >
                        <mat-option *ngIf="filteredSubsidiaries.length === 0" disabled>
                            No se encontraron resultados
                        </mat-option>

                        <mat-option
                            *ngFor="let subsidiary of filteredSubsidiaries"
                            [value]="subsidiary"
                        >
                            {{ formatSubsidiaryName(subsidiary) }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <ng-template #selectedSubsidiaryLabelTpl>
                <p
                    *ngIf="selectedSubsidiaryLabel"
                    class="text-sm font-semibold text-center mt-4"
                >
                    Subsidiaria: {{ selectedSubsidiaryLabel }}
                </p>
            </ng-template>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <!-- <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg">
        </div>
    </ng-container> -->
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden justify-between">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="justify-end items-center flex flex-row space-x-10 ">
            <p *ngIf="!isProd" class="font-bold p-3 bg-warn-400 rounded-3xl text-white">DESARROLLO</p>
            <p *ngIf="selectedSubsidiaryLabel" class="font-bold">
                Subsidiaria: {{ selectedSubsidiaryLabel }}
            </p>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->

</div>
